import { ArrayUtils } from '../../ArrayUtils';
import { HowlerSoundFile } from 'source/app/services/Sound/HowlerSoundFile';
import { Sounds } from '../Sounds';

let logEntrySound: HowlerSoundFile;
SetLogEntrySound(); // Initializes value (required in Mobile mode)

export function SetLogEntrySound(): HowlerSoundFile {
	logEntrySound = ArrayUtils.GetRandomElement([
		Sounds.feverStrings,
		Sounds.tfa_accomplishment
	]);
    
	return logEntrySound;
}

export function GetLogEntrySound(): HowlerSoundFile {
    return logEntrySound;
}
